<template>
    <div class="  is-fullheight sticky-sidebar" >
      <aside class="menu column  aside   is-fullheight" >
       <p class="menu-label">
Billing
      </p>
       <ul class="menu-list">
         <li>
           <a class="">General</a>
           <ul>
             <li @click="activeMenuLink = '/activities/listclients'"><router-link to="/activities/listclients"  :class="{'is-active':activeMenuLink === '/activities/listclients'}">List Clients</router-link></li>
             
           </ul>
         </li>
         
         
         
         
       </ul>
       
     </aside>
     
    </div>
 </template>
 
 <script>
 export default {
   name: 'SideBarActivities',
   components: {
   },
   data() {
     return { activeMenuLink: null }
   },
   mounted() {
     //this.activeMenuLink = this.$route.path.substring(1)
     this.activeMenuLink = this.$route.path
     console.log(this.activeMenuLink)
   },
   watch: {
    $route () { 
      
      this.activeMenuLink = this.$route.path
    },
    

  }
 }
 
 </script>